module.exports = __webpack_public_path__ + "img/beijing9.6a76fd00.jpg";